<template>
<div class="hover-animation-container" style="display: inline-grid">
  <div
    class="deliveryProvider CardContainer clickable"
    :class="{ 'active-provider': deliveryProvider == getStoreDeliveryProvider }"
    @click="changeDeliveryProvider(deliveryProvider)"
  >
    <div class="flex-row">
      <div>
        <img :src="`/owa/img/${deliveryProvider == 'TINY_MILE' ? 'other/tiny_mile.jpg' : 'icons/ms-icon-310x310.png'}`">
      </div>

      <div class="text-container">
        <v-chip v-if="!!providerDetails && (!providerDetails.errorCode || providerDetails.errorCode == 'ORD_ERR_DELIVERY_ADDRESS_OUT_OF_RANGE')"
          style="height: 22px; margin: 4px 0px"
        >
          <template v-if="!!getDeliveryAddress && !providerDetails.errorCode">
            {{ providerDetailsCost }} {{ $vuetify.t('$vuetify.cart.deliveryFee') }}
          </template>
          <template v-else>
            {{ $vuetify.t('$vuetify.cart.deliveryFee') }}: TBD
          </template>
        </v-chip>

        <div class="deliveryProvider-title">
          {{ $vuetify.t(`$vuetify.storePage.deliveryProvider[${deliveryProvider == 'TINY_MILE' ? 'robot' : 'human'}]`) }}
        </div>

        <div v-if="deliveryProvider == 'TINY_MILE'" class="deliveryProvider-sub-title">
          {{ $vuetify.t('$vuetify.storePage.deliveryProvider.byRobot') }}
        </div>
        <div v-else class="deliveryProvider-sub-title">
          {{ $vuetify.t('$vuetify.storePage.deliveryProvider.byHuman') }}
        </div>
      </div>
    </div>

    <div style="width: 100%; text-align: center">
      <v-chip v-if="deliveryProvider == 'TINY_MILE'" label outline color="info">
        {{ $vuetify.t('$vuetify.storePage.deliveryProvider.recommended') }}
      </v-chip>
    </div>

    <v-icon v-if="deliveryProvider == getStoreDeliveryProvider" id="selectedProvider" color="primary">
      check_circle_outline
    </v-icon>
  </div>
</div>
</template>

<script>
import { isNullOrEmpty } from "@/services/util.service"

import { mapGetters , mapMutations, mapActions } from 'vuex'
export default {
  props: {
    deliveryProvider: String
  },

  computed: {
    providerDetailsCost() {
      const { cost, fixedCost } = this.providerDetails

      if (cost !== undefined) {
        const prefix = !fixedCost ? 'Starting at ' : ''
        return prefix + this.$currency(cost / 100, false, true)
      }
      return null
    },
    providerDetails() {
      if (isNullOrEmpty(this.getDeliveryProvidersDetails))
        return {}
      return this.getDeliveryProvidersDetails.find(_provider => _provider.provider == this.deliveryProvider) || {}
    },

    ...mapGetters([
      'getStore',
      'getDeliveryAddress',
      'getDeliveryProvidersDetails',
      'getStoreDeliveryProvider'
    ])
  },

  methods: {
    setDeliveryProvider(newProvider) {
      let obj = this.getDeliveryProvider || {}
      obj[this.getStore.storeId] = newProvider

      this.SET_DELIVERY_PROVIDER(obj)
    },
    changeDeliveryProvider(deliveryProvider) {
      const oldProvider = this.getStoreDeliveryProvider

      // Change the state right away for better user experience
      this.setDeliveryProvider(deliveryProvider)

      this.$api.post(`/order/validate_address?provider=${deliveryProvider}`, this.getDeliveryAddress).then(() => {
        this.fetchShoppingCart()
      }).catch(error => {
        this.showSnack({
          text: `${this.$vuetify.t('$vuetify.storePage.deliveryProvider.notSupported', [this.$vuetify.t(`$vuetify.storePage.deliveryProvider[${deliveryProvider == 'TINY_MILE' ? 'robot' : 'human'}]`)])}`,
          color: 'warning'
        })

        // Change the deliveryProvider back if the validation failed
        this.setDeliveryProvider(oldProvider)
      })
    },

    ...mapMutations([ 'SET_DELIVERY_PROVIDER' ]),
    ...mapActions([ 'showSnack', 'fetchShoppingCart' ])
  }
}
</script>

<style>
  /* @media only screen and (min-width: 500px) {
    #deliveryProviderContainer {
      display: flex;
    }
  }
  @media only screen and (max-width: 500px) {
    #deliveryProviderContainer {
      padding-bottom: 1px;
    }

    .deliveryProvider {
      margin: 10px auto !important;
    }
  } */
</style>
<style scoped>
  .deliveryProvider {
    /* position: relative; */
    display: inline-block;

    width: 275px;
    height: 130px;
    /* border: 1.75px grey solid; */
    border-radius: 5px;

    padding: 5px 10px;
    margin: 10px;

    text-align: left;
  }
  .flex-row {
    display: flex;

  }
  .deliveryProvider.active-provider {
    border-color: var(--v-primary-base) !important;
  }

  .deliveryProvider img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }

  .deliveryProvider-cost {
    font-size: 14px;
    font-weight: 600;
  }

  .deliveryProvider .deliveryProvider-title {
    font-size: 22px;
  }
  .deliveryProvider .deliveryProvider-sub-title {
    font-size: 12px;
    color: grey;
  }

  #selectedProvider {
    position: absolute;
    top: -13px;
    right: -13px;

    background-color: white;
  }
</style>
